import type { InsertUserGroupMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertUserGroupDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertUserGroupInput = {
  Name: string;
  Email?: string | null;
  Description?: string | null;
  OwnerContributor?: boolean;
};

export const useInsertUserGroup = createMutationHook({
  name: 'insertUserGroup',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.userGroup.insert.mutationOptions({ onSuccess }),
  mapInput: (input: InsertUserGroupInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.userGroup.userGroupsWithApprovers.queryKey(),
    trpc.frontend.userGroup.userGroupById.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertUserGroupMutation => ({
    insert_user_group_one: {
      __typename: 'user_group',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertUserGroupDocument,
  graphqlVariables: (input: InsertUserGroupInput) => ({ ...input }),
  evictFields: ['user_group_user', 'user_group', 'user'],
});
